import { render, staticRenderFns } from "./shopApplyList.vue?vue&type=template&id=595ad319&scoped=true&"
import script from "./shopApplyList.vue?vue&type=script&lang=js&"
export * from "./shopApplyList.vue?vue&type=script&lang=js&"
import style0 from "./shopApplyList.vue?vue&type=style&index=0&id=595ad319&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595ad319",
  null
  
)

export default component.exports